module.exports = __webpack_public_path__ + "img/estate_bg.d3da34fd.jpg";